import React from 'react';
import { Card } from 'antd';
import { useParams } from 'react-router-dom';

const ProductsDetail: React.FC = () => {
  const { id } = useParams();

  return (
    <Card title="商品详情">
      商品详情页面 - ID: {id}
    </Card>
  );
};

export default ProductsDetail;
